module.exports = __webpack_public_path__ + "img/tagSign.061c7d01.png";